import { PageUrl } from '../../types/enums/pageUrl-enums';

/** Query `ActiveTab` values — aligned with CustomerManagement tab `code` pattern. */
export const STORE_CUSTOMER_ACTIVE_TAB_MANAGEMENT = 'StoreCustomerManagement';
export const STORE_CUSTOMER_ACTIVE_TAB_ORDERS = 'StoreOrderInformation';

export const DEFAULT_STORE_CUSTOMER_ACTIVE_TAB = STORE_CUSTOMER_ACTIVE_TAB_MANAGEMENT;

export const STORE_CUSTOMER_MENU_MANAGEMENT = 1;
export const STORE_CUSTOMER_MENU_ORDERS = 2;

export const resolveStoreCustomerMenuIdFromActiveTab = (activeTab: string | null): number => {
    if (activeTab === STORE_CUSTOMER_ACTIVE_TAB_ORDERS) {
        return STORE_CUSTOMER_MENU_ORDERS;
    }
    return STORE_CUSTOMER_MENU_MANAGEMENT;
};

export const buildStoreCustomerQuery = (activeTab: string): string => {
    const params = new URLSearchParams();
    params.set('ActiveTab', activeTab);
    return `${PageUrl.storeCustomerManagement.url}?${params.toString()}`;
};
